import Marionette from 'backbone.marionette';
import CommitteeMeetingEmptyViewTmpl from '../templates/committee_meeting_emptyview.tpl';
export default Marionette.ItemView.extend({
  template: CommitteeMeetingEmptyViewTmpl,
  tagname: 'div'
});